











import Vue from "vue";
import Component from "vue-class-component";
import { ConsultoresService } from "@/services/consultores.service";
import { Prop, Watch } from "vue-property-decorator";
import { required } from "@/shared/validators";

interface ComboItem {
  text: string;
  value: number;
}

@Component
export default class ComboNovoAtendimento extends Vue {
  @Prop() idConsultor!: number;
  @Prop(Number) readonly value!: number | undefined;

  loading = false;

  tipo: ComboItem | null = null;
  itemsTipo: ComboItem[] = [];

  @Watch("tipo")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  rules = {
    tipo: [required()],
  };

  async fetchTipos() {
    this.loading = true;
    const res = await ConsultoresService.PopAtendimento(this.idConsultor, null);
    this.itemsTipo = res.map((x) => ({
      text: x.descricao,
      value: x.idTipoAtendimento,
    }));

    if (this.value) {
      this.tipo = this.itemsTipo.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  async mounted() {
    await this.fetchTipos();
  }
}
